<template>
  <div class="deta" ref="deta" >

    <div class="main" ref="main" >

      <div class="banner">
        <img :src="deta.productBanner" alt="">
      </div>

      <div class="main_tab">
        <mu-tabs :value.sync="active"
                 @change="tabChange"
                 class="tab"
                 inverse
                 color="#3B9CFD"
                 indicator-color="#3B9CFD"
                 center>
          <mu-tab>套餐简介</mu-tab>
          <mu-tab>体检项目</mu-tab>
        </mu-tabs>

        <ul class="main_tab_deta" v-if="active == 0">
          <li>
            <h2>套餐简介</h2>
            <p>{{ deta.productDesc }}</p>
          </li>
          <li>
<!--            <h2>流程图</h2>-->
            <img :src="deta.productIntro" alt="">
          </li>
        </ul>

        <template v-if="deta.itemList.length != 0 && active == 1">
          <ul class="meal">
            <li class="meal_li" v-for="(item,index) in deta.itemList" :key="index" >
<!--              <template v-if="deta.productType == 1">-->
<!--                <h2 v-if="item.productCategory == 0" class="title">体检套餐</h2>-->
<!--                <h2 v-if="item.productCategory == 1" class="title">胃肠道筛查套餐</h2>-->
<!--                <h2 v-if="item.productCategory == 2" class="title">整合式筛查套餐</h2>-->
<!--                <h2 v-if="item.productCategory == 3" class="title">锦医未</h2>-->
<!--              </template>-->
              <h2 class="title">{{ item.itemTypeName }}</h2>
              <ul class="main_tab_deta">
                <li v-for="(items,indexs) in item.itemList" :key="indexs" >
                  <div class="main_tab_deta_title">
                    <h2>{{ items.itemName }}</h2>
                    <van-icon @click="seeDeta(items)" name="info" />
                  </div>
                  <p>{{ items.itemDesc }}</p>
                </li>
              </ul>
            </li>
          </ul>
        </template>

      </div>

    </div>


    <div class="footer" v-if="deta.productStatus == 1" ref="footer" >
      <p>¥ {{ deta.price }}</p>
      <mu-button @click="make(deta.productId)" round color="primary">立即预约</mu-button>
    </div>


  </div>
</template>

<script>
export default {
  name: "Deta",
  data() {
    return {
      active: 0,
      deta: {
        itemList: []
      },
    }
  },
  created() {

    this.get_deta(this.$route.query.id);
    this.$store.commit("setRouters",null)
    // 滚动条
    if(this.$refs.footer) {
      this.$refs.main.style.height  = this.$refs.deta.clientHeight - this.$refs.footer.clientHeight + "px"
    }

  },
  mounted() {
    // 分享
    // let data = this.$route.fullPath + "&fromUserId=" + this.$store.state.UserId;
    // this.$wxShare(data,"御锦健康","御锦健康与您在一起");
  },
  methods: {
    get_deta(e) {
      this.$get("product",e,true)
        .then(res => {
          if(res) {
            console.log(res.data);
            document.title= res.data.productName;
            this.deta= res.data;
          }
        })
    },
    tabChange(e) {
      console.log(e);
    },
    make(e) {
      this.$router.push({
        path: "/MakeSetMeal",
        query: {
          id: e,
          price: this.deta.price,
          name: this.deta.productName,
          isMake: true,
          fromUserId: this.$route.query.fromUserId ? JSON.parse(this.$route.query.fromUserId) ? this.$route.query.fromUserId : null : null
        }
      })
    },
    seeDeta(e) {
      this.$dialog.alert({
        title: e.itemName,
        message: e.itemDesc,
      }).then(() => {
        // on close
      });
    }
  }
}
</script>

<style lang="less" scoped>
  @import "../../../style/Make/MakeListDeta/Deta.less";
</style>
